(ns pfo.widget.upload (:require [reagent.core :as reagent :refer [atom]]
                                [pfo.util :as util]
                                [pfo.api :as api]
                                ["react-dropzone-component" :default ReactDropzone]))

(defn upload-field [options]
  [:> ReactDropzone {:config
             {:iconFileTypes [".jpg" ".png" ".gif"]
              :showFileTypeIcon true
              :postUrl (:url options)}
             :djsConfig (merge
                         {:maxFiles 1
                         :paramName "file"
                         :headers (api/auth-headers)
                         :addRemoveLinks true}
                         (when (:post-params options) {:params (:post-params options)}))
             :eventHandlers {:init (fn [^js dzone]
                                     (.on dzone "maxfilesexceeded"
                                          (fn [file]
                                            (.removeFile dzone file)))
                                     (when-let [remove-cb (:remove-cb options)]
                                       (.on dzone "removedfile" remove-cb)))
                             :error (:error-cb options)
                             :success (:success-cb options)}}])
